import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaPlayCircle } from "react-icons/fa";
import Breadcrumb from "../../Component/Breadcrumb";
import "./Gallery.css";
import { GalleryData } from "../../APIS/FetchAPIs";
import { useAuth } from "../../Store/AuthContext";

export default function Gallery() {
  const { RendomTokenfetch, Pagemetatags } = useAuth();
  const [DataGallery, loading] = GalleryData(RendomTokenfetch);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{Pagemetatags.gallery_title}</title>
        <meta name="description" content={Pagemetatags.gallery_description} />
        <meta name="keywords" content={Pagemetatags.gallery_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <Breadcrumb pagename={"Media Coverage"} mainpage="" />

      <section className="gallery-section section-padding">
        <div className="container">
          <div className="row g-4">
            {DataGallery.map((item, idx) => (
              <div
                className="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                key={idx}
                data-aos="zoom-in"
              >
                {/* ---------- Image ---------- */}
                {item.type === "1" && item.image && (
                  <div className="gallery-card">
                    <a href={item.image} data-fancybox="images" data-caption="">
                      <img
                        src={item.image}
                        alt={`Gallery ${idx}`}
                        className="gallery-img"
                      />
                      <div className="overlay">
                        <i className="fa fa-search"></i>
                      </div>
                      <span> {item.title}</span>
                    </a>
                  </div>
                )}

                {/* ---------- Video ---------- */}
                {item.type === "2" && item.video && (
                  <div className="gallery-card video-card">
                    {(() => {
                      let videoId = item.video;
                      if (videoId.includes("shorts")) {
                        videoId = videoId.split("/").pop();
                      } else if (videoId.includes("v=")) {
                        videoId = videoId.split("v=")[1].split("&")[0];
                      }
                      return (
                        <a
                          href={item.video}
                          data-fancybox="video"
                          data-caption=""
                        >
                          <img
                            src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                            alt={`Video ${idx}`}
                            className="gallery-img"
                          />
                          <div className="video-overlay">
                            <FaPlayCircle className="play-icon" />
                          </div>
                        </a>
                      );
                    })()}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
